import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import recommendedAdTemplate from './preview-mma-column.pug';

export class PreviewMMAColumn extends CampaignuiBaseColumn {
  constructor({
    deps = {
      adDisplayUrlService: null,
      combineText: null,
    },
    scope,
    i18n,
    newI18n,
  }) {
    const title = newI18n.getString(_TL_('Multimedia ad preview'));

    super({
      name: 'PreviewdMMA',
      property: 'PreviewdMMA',
      title,
      sortable: false,
      type: 'string',
      helpId: 'pop_BA_Recommendations_SuggestedAd',
      bodyClasses: ['suggested-mma-preview-column'],
      colClasses: ['mma-col-ads-preview'],
      helpAriaLabel: title,
    });

    this.scope = scope;
    this.deps = deps;
    this.i18n = i18n;
  }

  pickProperty(recommendation) {
    const opportunity = recommendation.Opportunities[0];
    const { OpportunityType } = opportunity;

    const {
      BusinessName,
      Images,
      FinalUrl,
    } = opportunity;

    let {
      Headline,
      Description,
    } = opportunity;

    const {
      Headlines,
      Descriptions,
    } = opportunity;

    Headline = _.result(_.first(Headlines), 'Text') || Headline;
    Description = _.result(_.first(Descriptions), 'Text') || Description;

    let landscapeImageMediaUrl = '';
    if (!_.isEmpty(Images)) {
      let imageUrlToUse = _.first(Images).ImageUrl;

      // strip off the resizing from MT as we need a smaller resizing
      const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
      if (indexOfResizeInfo > 0) {
        imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
      }

      const responsiveAdThumbnailWidth = 114;
      const responsiveAdThumbnailHeight = 60;
      const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;

      landscapeImageMediaUrl = `${imageUrlToUse}${resizeQueryString}`;
    }

    const pickProperities = {
      headlineCount: _.size(Headlines),
      textCount: _.size(Descriptions),
      imageCount: _.size(Images),
      Headline,
      BusinessName,
      FinalUrl,
      Text: Description,
      landscapeImageMediaUrl,
      convertedDisplayUrl:
      this.deps.adDisplayUrlService.getExpandedTextAdDisplayUrl(FinalUrl),
      i18n: this.i18n,
    };

    return _.defaults({
      OpportunityType,
    }, pickProperities);
  }

  get template() { return recommendedAdTemplate; }
}
